import { Controller } from "@hotwired/stimulus"
import { pushAnalyticsEvent } from "../modules/analytics"
import { showFlashHTML } from "../utils/flash_messages"

/**
 * CartItemUpdateController
 * 
 * Handles cart item quantity updates and removals via Turbo.
 * Replaces the legacy cart_items.js.erb file with a modern Turbo/Stimulus-based approach.
 * 
 * Usage:
 *   <form data-controller="cart-item-update" data-turbo-stream="true">
 *     ...
 *   </form>
 * 
 * Turbo Streams will handle most updates automatically.
 * This controller handles submit completion events for additional UI updates.
 */
export default class extends Controller {
  connect() {
    // Turbo handles form submission automatically
    // We just listen for completion events
  }

  disconnect() {
    // No cleanup needed - Turbo handles everything
  }

  /**
   * Handle form submission completion
   * @param {CustomEvent} event - Turbo submit-end event
   */
  handleSubmitEnd(event) {
    const { fetchResponse } = event.detail
    
    if (!fetchResponse) return

    // Success is handled by Turbo Streams automatically
    // We only need to handle errors here
    if (!fetchResponse.succeeded) {
      this.showFlashMessage(
        `<div class="alert alert-danger alert-dismissible fade show" role="alert">
          An error occurred while updating your cart.
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>`
      )
    }
  }



  /**
   * Display flash message using centralized utility
   * @param {string} content - HTML content for flash message
   */
  showFlashMessage(content) {
    showFlashHTML(content)
  }
}
